import { useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom'
import { useCookieConsent } from '../hooks/useCookieConsent'
import { initGA, logPageView } from '../lib/analytics'

export default function AnalyticsManager() {
  const { preferences } = useCookieConsent()
  const location = useLocation()
  const hasBootstrappedRef = useRef(false)
  const lastTrackedPathRef = useRef(null)

  // Initialize GA once consent for analytics is granted.
  useEffect(() => {
    if (!preferences?.analytics) {
      return
    }
    if (typeof window === 'undefined') {
      return
    }
    if (!window.GA_INITIALIZED) {
      const initialized = initGA()
      if (!initialized) {
        return
      }
    }
    if (!hasBootstrappedRef.current) {
      hasBootstrappedRef.current = true
      const currentPath = `${location.pathname}${location.search}${location.hash}`
      lastTrackedPathRef.current = currentPath
      logPageView(currentPath)
    }
  }, [preferences?.analytics, location.pathname, location.search, location.hash])

  // Track route changes once GA is active and consent remains granted.
  useEffect(() => {
    if (
      !preferences?.analytics ||
      !hasBootstrappedRef.current ||
      typeof window === 'undefined' ||
      !window.GA_INITIALIZED
    ) {
      return
    }
    const currentPath = `${location.pathname}${location.search}${location.hash}`
    if (lastTrackedPathRef.current === currentPath) {
      return
    }
    lastTrackedPathRef.current = currentPath
    logPageView(currentPath)
  }, [preferences?.analytics, location.pathname, location.search, location.hash])

  return null
}
